import styled from '@emotion/styled';
import Button, { ButtonProps } from '@portalterreno/react-ui-core/Button';

export type StyledPlanButtonProps = ButtonProps;

const StyledPlanButton = styled(Button)<StyledPlanButtonProps>(
  {
    'backgroundColor': 'transparent',
    'border': 'none',
    'cursor': 'pointer',
    'padding': 0,
    '&:hover, &:active': {
      backgroundColor: 'transparent'
    }
  },
  ({ theme }) => ({
    'fontSize': theme.typography.fontSize.medium,
    '&:hover, &:active': {
      color: theme.palette.colors.coolGrey
    },
    'a': {
      '&:link, &:visited': {
        color: theme.palette.colors.white
      },
      '&:hover, &:active': {
        color: theme.palette.colors.coolGrey
      }
    }
  })
);

export default StyledPlanButton;
